import {ModelCode} from '../promotions/model-codes.model';

export class ModelCodeList {

  dataList: ModelCode[];
  pageCount: number;
  rowCount: number;

}
